import { ProtocolType } from 'models/ScheduledProtocol';

import { TicketSectionId } from 'views/WorkQueue/WorkQueue.types';

export const sharedTestSelectors = {
  lightweightPathwayQuestionContainer: (questionId: string) =>
    `lightweight-pathway-question-${questionId}`,
  lightweightPathwaySingleQuestionOption: (optionId: string) =>
    `lightweight-pathway-single-question-answer-${optionId}`,
  lightweightPathwayMultipleQuestionOption: (optionId: string) =>
    `lightweight-pathway-multiple-question-answer-${optionId}`,
  lightweightPathwayTextQuestionInput: (questionId: string) =>
    `lightweight-pathway-text-question-input-${questionId}`,
  reportProtocolSelectButton: 'report-protocol-select-button',
  reportProtocolSelectMenu: 'report-protocol-select-button-menu',
  reportProtocolSelectValue: 'report-protocol-select-button-value',
  reportProtocolSelectOption: (option: ProtocolType) => `report-protocol-select-button-${option}`,
  switchProtocolPopup: 'switch-protocol-popup',
  firstNameInput: 'first-name-input',
  lastNameInput: 'last-name-input',
  mrnInput: 'mrn-input',
  dobInput: 'dob-input',
  sexSelect: 'Sex',
  languageSelect: 'Language Preference',
  phoneNumberInput: 'phoneNumberInput',
  email: 'emailInput',
  phoneTypeSelect: 'Phone Type',
  primaryProviderSelect: 'Primary Provider',
  primaryLocationSelect: 'Primary Location',
  serviceConsentCheckbox: 'service-consent-checkbox',
  copayConsentCheckbox: 'copay-consent-checkbox',
  readTermsCheckbox: 'read-terms-checkbox',
  enrollmentStatus: {
    chemoTech: 'enrollment-status-chemo-teach',
    established: 'enrollment-status-established'
  },
  actionsButton: {
    pathwayOption: function (pathwayId?: string) {
      if (pathwayId) {
        return `${pathwayId}-option`;
      }

      return 'no-pathway-option';
    }
  },
  ticketSection: {
    container: (sectionId: TicketSectionId) => `${sectionId}-section`,
    collapse: (sectionContainerId: string) => `collapse-${sectionContainerId}`,
    trigger: (sectionContainerId: string) => `trigger-${sectionContainerId}`
  }
};
